import { Router, RouterOutlet } from '@angular/router';
import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { WebhookService } from './webhook.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TwilioService } from './twilio.service';
import { environment } from '../../../environments/environment';
import { LocalCacheService } from '../../services/localCache.service';
import { NgxBraintreeService } from '../../services/ngx-braintree.service';
import { GlobalService } from '../../services/global.service';
import { throwError } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { QuoteService } from '../../services/quote.service';
@Component({
  selector: 'app-ivr-widget',
  standalone: true,
  imports: [
    RouterOutlet,
    FormsModule,
    HttpClientModule,
    CommonModule,
    DialogModule,
    ProgressBarModule,
  ],
  providers: [WebhookService, TwilioService, NgxBraintreeService],
  templateUrl: './ivr-widget.component.html',
  styleUrl: './ivr-widget.component.scss',
})
export class IVRWidgetComponent implements OnInit {
  private _paymentToken: string = '';

  @Input() autoClub: string = environment.autoClub;
  @Input() totalAmount: any;
  @Input() quoteId: any;
  title = 'IVR-Payment-Client';
  cardNumber: string = '';
  cvv: string = '';
  expiryDate: string = '';
  postalcode = '';
  sip: string = '';
  pksid: string = '';

  agentUniqueId: string = 'agent-1002';
  message: any;
  realTimeData: any;
  sessionStarted = false;
  completePaymentStarted = false;
  allValidationItems = [
    'payment-card-number',
    'security-code',
    'expiration-date',
  ];
  payRequest = {
    autoClub: 'W2C',
    paymentMethod: '',
    amount: '',
    orderId: '',
    token: '',
  };
  completePurchaseObject: any;
  emptyPayRequest = Object.assign({}, this.payRequest);

  paymentResponse = {
    paymentConfirmationNumber: '',
    processorResponseCode: '',
    processorResponseText: '',
    processorSettlementResponseCode: '',
    processorSettlementResponseText: '',
    additionalProcessorResponse: '',
    networkResponseCode: '',
    networkResponseText: '',
    message: '',
    status: false,
  };
  emptyPaymentResponse = Object.assign({}, this.paymentResponse);

  paymentResponseStr: string = '';
  requiredParams: string[] | undefined;
  callMessage = '';
  unsuccessfulMessage: any;
  paymentStatusCode = 0;
  eventTriggered = '';
  quoteDetail: any;
  paymentCardType: string = '';
  cardType = ['visa', 'mastercard'];

  timeLeftForCardNumber: number = 0;
  private interval: any;
  timeLeftForCVV: number = 0;
  timeLeftForEXP: number = 0;

  set paymentToken(value: string) {
    this._paymentToken = value; // Save the new value
    this.onPropertyChange(value); // Trigger the method
  }

  get paymentToken(): string {
    return this._paymentToken; // Getter to retrieve the value
  }

  constructor(
    private http: HttpClient,
    private webhookService: WebhookService,
    private twilioService: TwilioService,
    private router: Router,
    private localCacheService: LocalCacheService,
    private globalService: GlobalService,
    private bindService: NgxBraintreeService,
    private quoteService: QuoteService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.webhookService.agentUniqueId = this.agentUniqueId;
  }
  onPropertyChange(token: string) {
    if (token) {
      //If token is available then start finalize the payment and bind the policy.
      this.pay();
    }
  }

  updateValidationUI(dataString: string) {
    const params = new URLSearchParams(dataString);

    this.cardNumber = params.get('PaymentCardNumber') ?? '';
    this.cvv = params.get('SecurityCode') ?? '';
    this.expiryDate = params.get('ExpirationDate') ?? '';
    this.postalcode = params.get('PaymentCardPostalCode') ?? '';
    this.paymentToken = params.get('PaymentToken') ?? '';
    this.paymentCardType = params.get('PaymentCardType') ?? '';

    this.requiredParams = params.get('Required')?.split(',');
    this.allValidationItems.forEach((item) => {
      this.requiredItemReset(item);
    });
  }
  resetField(captureType: string) {
    switch (captureType) {
      case 'payment-card-number':
        this.cardNumber = '';
        break;
      case 'security-code':
        this.cvv = '';
        break;
      case 'expiration-date':
        this.expiryDate = '';
        break;
      default:
        break;
    }
  }
  requiredItemReset(item: any) {
    let invalid = false;
    if (isPlatformBrowser(this.platformId)) {
      const listItem = document.getElementById(item); // Assumes each item has an id corresponding to its name
      const icon = listItem?.querySelector('.icon');

      if (this.requiredParams) {
        if (this.requiredParams?.includes(item)) {
          icon?.classList.remove('fa-check-circle', 'text-success');
          icon?.classList.add('fa-exclamation-circle', 'text-danger');
          invalid = true;
        } else {
          icon?.classList.remove('fa-exclamation-circle', 'text-danger');
          icon?.classList.add('fa-check-circle', 'text-success');
        }
      } else {
        invalid = true;
      }
    }
    return invalid;
  }

  checkIfCardCapturedInvalid() {
    return (
      this.requiredItemReset('payment-card-number') ||
      this.requiredItemReset('security-code') ||
      this.requiredItemReset('expiration-date')
    );
  }

  ngOnInit() {
    this.quoteDetail = this.localCacheService.getSessionStorage('quoteDetail');
    this.webhookService.closeHubConnection();

    //Triggered when start capture card - Step 3.x
    this.webhookService.creditCardInfo$.subscribe((cardInfo: any) => {
      if (cardInfo && this.sessionStarted) {
        console.log(cardInfo);
        this.updateValidationUI(cardInfo);
      }
    });

    this.webhookService.message$.subscribe((_message) => {
      if (_message) {
        const decodedString = decodeURIComponent(_message);
        this.message = decodedString;
      }
    });

    var callInfo = this.localCacheService.getSessionStorage('callinfo');
    if (callInfo) {
      this.sip = callInfo?.sip;
      this.pksid = callInfo?.pksid;
    }
  }

  startTimer(captureType: string) {
    switch (captureType) {
      case 'payment-card-number':
        this.timeLeftForCardNumber = 5;
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (this.timeLeftForCardNumber > 0) {
            this.timeLeftForCardNumber--;
          } else {
            this.timeLeftForCardNumber = 0;
            clearInterval(this.interval);
          }
        }, 1000);
        break;
      case 'security-code':
        this.timeLeftForCVV = 5;
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (this.timeLeftForCVV > 0) {
            this.timeLeftForCVV--;
          } else {
            this.timeLeftForCVV = 0;
            clearInterval(this.interval);
          }
        }, 1000);
        break;
      case 'expiration-date':
        this.timeLeftForEXP = 5;
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (this.timeLeftForEXP > 0) {
            this.timeLeftForEXP--;
          } else {
            this.timeLeftForEXP = 0;
            clearInterval(this.interval);
          }
        }, 1000);
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
  // Start Payment session - Step 2.1
  startCapturePayment() {
    this.webhookService.addToGroup(this.sip).then(() => {
      this.sessionStarted = false;
      this.twilioService.makePayment(this.sip).subscribe(
        (response) => {
          this.pksid = response?.sid || '';
          this.syncCallPKId(this.quoteDetail.quoteId, this.sip, this.pksid);
          let responseMessage = this.showErrorMessage(response);
          if (responseMessage) {
            this.sessionStarted = false;
            this.callMessage = responseMessage;
            return;
          }
          this.sessionStarted = true;
          this.localCacheService.saveSessionStorage('callinfo', {
            sip: this.sip,
            pksid: this.pksid,
          });
          this.checkCallStatus(response);
          console.log(response);
        },
        (error) => {
          this.sessionStarted = false;
          console.error(error);
        },
      );
    });
  }

  showErrorMessage(response: any, operation = '') {
    if (!response) return 'Something went wrong. Please try again!';
    if (response?.message && response?.status == 404) {
      return 'Please validate the transaction id and try again!';
    }
    if (response?.message && response?.status == 400) {
      return `${response?.message} You can clear session and try again!`;
    }
    if (response?.message) {
      return response?.message;
    }
    if (response?.sid && response?.call_sid) {
      if (operation == 'cancel') {
        return 'Payment session has been cleared successful.';
      }
    }
    return '';
  }
  syncCallPKId(quoteId: string, sid: string, pkid: string) {
    let callInfo = {
      quoteGuid: quoteId,
      ivrcallSid: sid,
      ivrcallPkid: pkid,
    };

    this.quoteService
      .updateSubmissionElement(callInfo)
      .subscribe((callInfo) => {
        this.pksid = callInfo.ivrcallPkid;
      });
  }
  // Complete/Cancel session to start/end the pay - Step 2.2
  completeOrCancelPayment(status: string) {
    if (this.paymentCardType && !this.cardType.includes(this.paymentCardType)) {
      this.callMessage = `The card type [${this.paymentCardType}] is not allowed for payment.`;
      return;
    }
    if (status == 'complete') {
      this.completePaymentStarted = true;
    }
    //var callInfo = this.localCacheService.getSessionStorage('callinfo');
    if (this.sip && this.pksid) {
      this.twilioService
        .captureCard(this.sip, this.pksid, '', status)
        .subscribe(
          (response) => {
            this.checkCallStatus(response);
            if (status == 'cancel') {
              this.clearSession();
              let responseMessage = this.showErrorMessage(response, status);
              if (responseMessage) {
                this.sessionStarted = false;
                this.callMessage = responseMessage;
              }
            } else {
              this.completePaymentStarted = false;
            }
            console.log(response);
          },
          (error) => {
            console.error(error);
          },
        );
    }
  }

  //Start/Reset capture card info - Step 3
  startCaptureCard(captureType: string) {
    this.resetField(captureType);
    if (!this.requiredParams?.includes(captureType)) {
      this.requiredParams?.push(captureType);
    }
    this.requiredItemReset(captureType);

    this.twilioService.captureCard(this.sip, this.pksid, captureType).subscribe(
      (response: any) => {
        //this.pksid = response.sid;
        this.checkCallStatus(response);
        this.startTimer(captureType);
        console.log(response);
      },
      (error) => {
        console.error(error);
      },
    );
  }

  // Payment through LTX API (using braintree api) - Step 4 - Done!
  pay() {
    this.completePurchaseObject = {
      quoteId: this.quoteId,
      autoClub: this.autoClub,
      amount: this.totalAmount,
      cashReceiptNumber: '',
      token: this.paymentToken,
      methodType: 'IVRPAY',
      sid: this.sip,
    };

    const agentGuid = this.localCacheService.getSessionStorage('agentGuid');
    const branchGuid = this.localCacheService.getSessionStorage('branchGuid');
    if (agentGuid) {
      this.completePurchaseObject.agentInfo = {
        agentGuid: agentGuid,
        branchGuid: branchGuid || '',
      };
    }

    //Make server call to settle the payment
    this.bindService.createPurchase('', this.completePurchaseObject).subscribe({
      next: (response: any) => {
        if (response) {
          if (response && response?.status === 'Failed') {
            this.unsuccessfulMessage =
              'Something went wrong! Please contact customer support for assistance.';
          } else {
            var strResult = JSON.stringify(response);
            console.log(strResult);
            this.localCacheService.saveSessionStorage('paymentInfo', strResult);
            var sendPolicyObj: any = {
              movementGuid: response.movementGuid,
              movementType: 'NB',
            };
            this.bindService
              .sendPolicy(sendPolicyObj)
              .subscribe((response) => {});
            this.globalService.checkAndValidatePage(4, true);
            this.router.navigate(['payment-confirmation']);
          }
        }
      },
      error: (error: any) => {
        console.log('createPurchase error', error);
        this.paymentStatusCode = error?.StatusCode || 0;
        if (error && error?.Success === false && error?.StatusCode !== 500) {
          this.unsuccessfulMessage = error?.Message;
        } else {
          this.unsuccessfulMessage =
            'Something went wrong! Please contact customer support for assistance.';
          throwError(error);
        }
      },
    });
  }

  clearSession() {
    this.payRequest = this.emptyPayRequest;
    this.paymentResponse = this.emptyPaymentResponse;
    this.cardNumber = '';
    this.cvv = '';
    this.expiryDate = '';
    this.postalcode = '';
    //this.sip = '';
    //this.pksid = '';
    this.paymentToken = '';
    this.paymentCardType = '';
    this.itemIconReset();
    this.sessionStarted = false;
    this.localCacheService.removeSessionStorage('callinfo');
    this.callMessage = '';
  }

  itemIconReset() {
    if (isPlatformBrowser(this.platformId)) {
      this.allValidationItems.forEach((item) => {
        const listItem = document.getElementById(item); // Assumes each item has an id corresponding to its name
        const icon = listItem?.querySelector('.icon');
        icon?.classList.remove('fa-check-circle', 'text-success');
        icon?.classList.add('fa-exclamation-circle', 'text-danger');
      });
      this.requiredParams = this.allValidationItems;
    }
  }

  onClose() {
    this.callMessage = '';
  }

  checkCallStatus(response: any) {
    if (response?.status != 200) {
      if (response?.message) {
        this.callMessage = response?.message;
      }
      // else {
      //   this.callMessage = 'Something went wrong. Please check call state and try again!';
      // }
    }
  }
  hideUnsuccessfulAlert() {
    this.unsuccessfulMessage = '';
    if (this.paymentStatusCode === 2001) {
      // Reload widget for Insufficient Funds declined error.
    }
  }
}
